var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTaskOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#00ADEE",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "task-open_svg__cls-1",
    d: "M22 31a9.1 9.1 0 01-2.47-.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "task-open_svg__cls-2",
    d: "M15.57 28.3a9 9 0 011.83-14",
    strokeDasharray: "4.65 4.65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "task-open_svg__cls-1",
    d: "M19.53 13.34A9.1 9.1 0 0122 13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "task-open_svg__cls-3",
    d: "M22 13h0a9 9 0 019 9h0a9 9 0 01-9 9h0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "task-open_svg__cls-1",
    d: "M19 22l2 2 4-4"
  })));
}

export default SvgTaskOpen;